import React from "react";
import WavyDivider from "./WavyDivider";
import { siteData } from "../mock";

const PourQui = () => {
  return (
    <section id="pourqui" className="section pourqui">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Les bienfaits du Shiatsu</h2>
        <h3 className="section-subtitle">
          Le Shiatsu s’adresse à tout public (sauf pathologies graves ou grossesse de moins de 3 mois).
          <br />Il harmonise le corps et l’esprit et apporte un état de détente profonde et durable.
        </h3>
      </div>

      <div className="patho-grid">
        {siteData.pathologies.map((p) => (
          <div className="patho-card" key={p.title}>
            <span className="patho-dot" />
            <h4 className="patho-title">{p.title}</h4>
            <p className="patho-desc">{p.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PourQui;
